import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 马拉松 共用
import marathonRouter from '@router/marathon/commonRouter'
// 【横琴马拉松】
import marathonRouter_HengqinRouter from '@router/marathon/hengqin'

const {
  MarathonDataAnalyseIndex,
  MarathonSignupIndex,
  MarathonGamesTimeResultsIndex,
  MarathonLiveMonitoringIndex,
  MarathonVideoSectionCameraIndex,
  MarathonVideoSectionPlayerIndex,
  MarathonVideoCollectionSettingIndex,
  MarathonVideoCollectionPlayerIndex,
  MarathonBroadcastListIndex,
  MarathonDataPackagListIndex,
  MarathonProgramListIndex,
} = marathonRouter

const { PlatfromMarathonHengqinFull } = marathonRouter_HengqinRouter

const pathModuleBase = 'platfromMarathonFull'
const diffCompetitionTypeArr = [
  {
    name: 'Hengqin',
    pathModule: 'HengqinMara',
    component: PlatfromMarathonHengqinFull,
  }, //  横琴马拉松
]

const baseChildren = [
  {
    path: 'dataAnalyse', //marathon/重庆/数据分析
    name: 'marathonDataAnalyseIndex', // marathonDataAnalyseIndex_Hengqin
    component: MarathonDataAnalyseIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'dataAnalyse'],
      requireLogin: false,
      title: '数据分析',
    },
  },
  {
    path: 'signup', //marathon/重庆/报名数据
    name: 'marathonSignupIndex',
    component: MarathonSignupIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'signup'],
      requireLogin: false,
      title: '报名数据',
    },
  },
  {
    path: 'gamesTimeResults', //marathon/重庆/赛时成绩
    name: 'marathonGamesTimeResultsIndex',
    component: MarathonGamesTimeResultsIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'gamesTimeResults'],
      requireLogin: false,
      title: '赛时成绩',
    },
  },
  {
    path: 'liveMonitoring', //marathon/重庆/直播监看
    name: 'marathonLiveMonitoringIndex',
    component: MarathonLiveMonitoringIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'liveMonitoring'],
      requireLogin: false,
      title: '直播监看',
    },
  },
  {
    path: 'videoSectionCamera', //marathon/重庆/视频切片-摄像机位
    name: 'marathonVideoSectionCameraIndex',
    component: MarathonVideoSectionCameraIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'videoSection'],
      requireLogin: false,
      title: '视频切片',
    },
  },
  {
    path: 'videoSectionPlayer', //marathon/重庆/视频切片-运动员切片
    name: 'marathonVideoSectionPlayerIndex',
    component: MarathonVideoSectionPlayerIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'videoSection'],
      requireLogin: false,
      title: '视频切片',
    },
  },
  {
    path: 'videoCollectionSetting', //marathon/重庆/视频集锦-集锦设置
    name: 'marathonVideoCollectionSettingIndex',
    component: MarathonVideoCollectionSettingIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'videoCollection'],
      requireLogin: false,
      title: '视频集锦',
    },
  },
  {
    path: 'videoCollectionPlayer', //marathon/重庆/视频集锦-运动员集锦
    name: 'marathonVideoCollectionPlayerIndex',
    component: MarathonVideoCollectionPlayerIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'videoCollection'],
      requireLogin: false,
      title: '视频集锦',
    },
  },
  {
    path: 'broadcastList', //马拉松 播出单
    name: 'marathonBroadcastListIndex',
    component: MarathonBroadcastListIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //马拉松 数据包装
    name: 'marathonDataPackagListIndex',
    component: MarathonDataPackagListIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //马拉松 节目单
    name: 'marathonProgramListIndex',
    component: MarathonProgramListIndex,
    meta: {
      pathModule: ['marathon', 'HengqinMara', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)

const routerModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /HengqinMara
  name: `${pathModuleBase}_${routerItem.name}`, // platfromMarathonFull_Hengqin
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))
export default {
  marathon_RouterMode: routerModeArr[0],
}
